import { PdRatingList } from "./pd-rating/PdRatingList.js";
//#region src/pd-rating/pd-rating-list.ts
var tag = "pd-rating-list";
if (!customElements.get(tag)) customElements.define(tag, PdRatingList);
//#endregion
export { PdRatingList };
